import React from 'react';
import SqftStore from "../../../canvas/store/sqftStore";
import SvgIcon from "@mui/material/SvgIcon";
import {ScreenshotIcon} from "../../../../../common/icons";
import COLOR_THEMES from "../../../../../../colorThemes";
import {FormattedMessage, injectIntl} from "react-intl";
import Button from "@mui/material/Button";
import {changeSqftFeaturesPopup, setAPIErrorMessage, setSqftCabinetsGlb} from "../../../../../../actions/sqftFunctions";
import {setSQFTAr3dPopup} from "../../../../../../actions/sqftMenuFunctions";
import {connect} from "react-redux";
import workspaceControllers from "../../../canvas/store/workspaceControllers";

const ScreenshotButton = (props) => {
  const {activeTheme, isMobile} = props;

  const saveScreenshot = () => {
    const viewGL = SqftStore.viewGL;

    if (viewGL && viewGL.renderer) {
      // Ensure renderer is ready
      const canvas = viewGL.renderer.domElement;
      canvas.toBlob((blob) => {
        const link = document.createElement('a');
        link.style.display = 'none';
        document.body.appendChild(link);
        link.href = URL.createObjectURL(blob);
        link.download = '3Dscreenshot.png';
        link.click();

        // Save screenshot as Base64 string to the resource
        const reader = new FileReader();
        reader.onloadend = () => {
          const base64data = reader.result;
          workspaceControllers.images3d.addResource(base64data);
        };
        reader.readAsDataURL(blob);

      }, 'image/png');
    } else {
      console.error('Renderer instance not found');
    }
  };
  const screenshotIconStyle = isMobile ? { marginLeft: "13px", marginTop: "7px"} : { marginLeft: "5px", marginTop: "5px"}

  return (
    <Button className={"ui-button2 ui-button2--medium ui-button2--primary-border"}
            style={{backgroundColor: "white"}}
            startIcon={(
              <SvgIcon style={screenshotIconStyle} >
                <ScreenshotIcon color={COLOR_THEMES[activeTheme].primary} />
              </SvgIcon>
            )}
            onClick={() => saveScreenshot()}>
      {
        isMobile ? "" : <FormattedMessage id="sqft.popup.button.save3dImage"/>
      }
    </Button>
  );
};

const mapStateToProps = (store) => {
  const {isMobile} = store.serverState;
  return {
    isMobile,
    activeTheme: store.serverState.activeTheme,
  };
};
const mapDispatchToProps = {
  setSqftCabinetsGlb,
  setSQFTAr3dPopup,
  changeSqftFeaturesPopup,
  setAPIErrorMessage,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(ScreenshotButton)
)

